// Gallery Modal
const galleryModalMain = document.querySelectorAll('[data-slider="gallery-modal-main"]');
const galleryModalThumb = document.querySelectorAll('[data-slider="gallery-modal-thumb"]');

const galleryModalThumbOptions = {
  slidesPerView: 'auto',
  spaceBetween: 12,
  watchOverflow: true,
  centerInsufficientSlides: true,
  slideToClickedSlide: true,
  1023: {
    spaceBetween: 10,
  },
};

const initGalleryThumbSlider = () => {
  galleryModalThumb.forEach((el) => {
    const parentEle = el.closest('[data-slider-parent]');

    if (windowWidth() > 767) {
      new Swiper(el, galleryModalThumbOptions);
    } else {
      enableScrollbarSync(parentEle);
    }
  });
};

initGalleryThumbSlider();

setupResponsiveSliders({
  sliderElements: galleryModalThumb,
  breakpoint: 767,
  initSlider: initGalleryThumbSlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});

const galleryModalMainOptions = {
  slidesPerView: 1,
  watchOverflow: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

const scrollThumbIntoView = (el, container) => {
  const elRect = el.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  if (elRect.left < containerRect.left + 16) {
    container.scrollBy({
      left: elRect.left - containerRect.left - 16,
      behavior: 'smooth',
    });
  } else if (elRect.right > containerRect.right - 16) {
    container.scrollBy({
      left: elRect.right - containerRect.right + 16,
      behavior: 'smooth',
    });
  }
};

const setActiveThumb = (parentElem, activeIndex) => {
  if (windowWidth() >= 767) return;

  const thumbSlider = parentElem.querySelector('.gallery-modal__thumb-slider .swiper');
  if (!thumbSlider) return;

  const thumbSlides = thumbSlider.querySelectorAll('[data-modal-slide]');
  thumbSlides.forEach((thumb) => thumb.classList.remove('is-thumb-active'));

  const activeThumb = thumbSlides[activeIndex];

  activeThumb.classList.add('is-thumb-active');
  scrollThumbIntoView(activeThumb, thumbSlider);
};

galleryModalMain.forEach((el, i) => {
  const parentElem = el.closest('.gallery-modal');
  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');

  galleryModalMainOptions.navigation.prevEl = arrowLeft;
  galleryModalMainOptions.navigation.nextEl = arrowRight;
  galleryModalMainOptions.thumbs.swiper = galleryModalThumb[i].swiper;

  const galleryModalSlider = new Swiper(el, galleryModalMainOptions);

  galleryModalSlider.on('slideChange', () => {
    setActiveThumb(parentElem, galleryModalSlider.realIndex);
  });

  attachEvent('[data-modal-slide]', 'click', (ev) => {
    const targetSlideEle = ev.target.closest('[data-modal-slide]');
    const targetSlideAttr = targetSlideEle.getAttribute('data-modal-slide');
    const slideIndex = parseInt(targetSlideAttr, 10) - 1;
    if (isNaN(slideIndex)) return;

    galleryModalSlider.slideTo(slideIndex, 0);
    setActiveThumb(parentElem, slideIndex);
  });
});

// Close modal
attachEvent('[data-close-modal]', 'click', (ev) => {
  toggleModal(ev.target, false);
});

// Open modal
attachEvent('[data-gallery-trigger]', 'click', (ev) => {
  ev.preventDefault();
  toggleModal(ev.target, true);
});
